import React from 'react';
import RegrasExtrasFlexService from '../../../../lib/api/regrasExtrasFlex/regrasExtrasFlex';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class RegrasExtrasFlex extends React.Component<{}, {}> {
	constructor(props: any) {
		super(props);
		this.state = {};
	}

	baixarExcelParametrosRegrasExtrasFlex() {
		return RegrasExtrasFlexService.obterExcel();
	}

	enviarParametrosEventGrid() {
		return RegrasExtrasFlexService.enviarParametrosAoEventGrid();
	}

	render() {
		return (
			<TemplateParametro
				enviarParametrosEventGrid={this.enviarParametrosEventGrid}
				baixarExcelParametros={this.baixarExcelParametrosRegrasExtrasFlex}
				enviarExcelParametros={RegrasExtrasFlexService.regrasExtrasFlexExcelPost}
				deletarExcelParametros={RegrasExtrasFlexService.deletarExcelParametros}
				nomeDoArquivo='Regras Extras Flex'
			/>
		);
	}
}

export default RegrasExtrasFlex;
